<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r4">힙 히스토그램</div>
      <el-button class="mr-l4 mr-r4" size="mini" @click="loadData"><i class="far fa-sync-alt"/></el-button>
      <el-button class="mr-r4" size="mini" type="primary" @click="executeGC">GC 수행</el-button>
      <el-button class="mr-r4" size="mini" @click="resetCache">캐시 삭제</el-button>
    </div>
    <div>
      <el-button size="small" @click="exportHeapHisto"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="tableData" v-loading="isLoading" :column-default="columnDefault" :columns="columns" :pagination="true" :defaultSort="defaultSortCol"
   :show-custom-header="true" :show-search-tool="showSearchTool" :total="totalData" style="width:100%;">
  </el-table-wrapper>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty } from 'lodash';
import MsgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import FileApi from '@/api/common/file';
import ApmConfigAPI from '@/api/config/apm/apm-info';

export default {
  name: 'WHeapInfoNode',
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      tableData: [],
      totalData: 0,
      defaultSortCol: { prop: 'count', order: 'descending' },
      osCheckDatetime: null,
      isLoading: false,
      showSearchTool: false,
      params: {
        objId: null,
      },
      columns: [
        {
          prop: 'className',
          label: '클래스 이름',
          width: 900,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'count',
          label: '개수',
          sortable: true,
          searchable: true,
          formatter: this.convertCountValue,
        },
        {
          prop: 'size',
          label: '크기(byte)',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WHeapInfoNode') {
          this.initData();
          this.loadData();
        }
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WHeapInfoNode') {
          this.initData();
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.totalData = 0;
      this.tableData = [];
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    loadData() {
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      ApmConfigAPI.getHeapHistoryList({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          if (Object.entries(response.data.data).length > 0) {
            this.totalData = response.data.data.values.length;
            this.tableData = response.data.data.values;
          } else {
            this.totalData = 0;
            this.tableData = [];
          }
        }
        this.isLoading = false;
      });
    },
    convertCountValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'count', true, false, true);
    },
    getConvertSizeByBData(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'Byte', true, true, true);
    },
    executeGC() {
      this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.RUN)).then(() => {
        ApmConfigAPI.executeSystemGC({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RUN, 'GC 수행', response.data.success));
          }
        });
      }).catch(() => {});
    },
    resetCache() {
      this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.RUN)).then(() => {
        ApmConfigAPI.executeResetCache({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.RUN, '캐시 삭제', response.data.success));
          }
        });
      }).catch(() => {});
    },
    exportHeapHisto() {
      if (!isNil(this.selectedNode)) {
        const params = {
          objId: this.selectedNode.obj.objId,
        };
        ApmConfigAPI.getHeaphistoInfoExcelName(params).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/heap/index.vue